import React, { useState } from "react";
import WishListCard from "../organisms/WishListCard";


const Wishlist = () => {
  const [showProject, setShowProject] = useState(true);

  return (
    <div className="w-full">
      <h1
        className="mt-5 mb-5 ml-5 text-2xl font-bold"
        onClick={() => setShowProject(true)}
      >
        Wishlist
      </h1>

      <div
        className="bg-gray-100 w-full 
      "
      >
        <WishListCard />
      </div>
    </div>
  );
};

export default Wishlist;